<template>
  <div class="sign">
    <!-- 签名 -->
    <el-dialog
      title="签名确认"
      :visible.sync="dialogSignVisible"
      width="530px"
      :before-close="handleSignClose"
      @open="init"
    >
      <el-form :model="ruleSignForm" ref="ruleForm" class="sign-ruleForm">
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            placeholder="请输入审批意见"
            v-model="ruleSignForm.remarks"
            maxlength="50"
            show-word-limit
            resize="none"
            rows="3"
          />
        </el-form-item>
      </el-form>
      <div class="sign-container" id="sign-water">
        <img v-if="signImg" class="sign-img" :src="signImg">
        <vue-esign
          v-show="!signImg"
          ref="esign"
          :width="466"
          :height="340"
          :isCrop="isCrop"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
        <div class="clear-sign">
          <el-button type="text" class="btn-text" @click="clearSign"
            >重新签名</el-button
          >
        </div>
        <p class="sign-tips">请在该区域签名</p>
      </div>
      <div class="tips">
        <img class="tips-img" src="../assets/tips.png" />
        <span class="tips-text">请确定无误后再进行签字确认</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleSignClose">取 消</el-button>
        <el-button type="primary" @click="confirmAgree">确认同意</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import ImgUploader from '@/models/img-upload'
const imgUploader = new ImgUploader();
import WaterMark from "@/common/js/waterMark.js";
import FinanceApproval from "@/models/finance-approval.js";
export default {
  props: ['dialogSignVisible', 'signApprovalData'],

  data() {
    return {
      ruleSignForm: {
        remarks: "",
      },
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      signImg: "",
      // 是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
      isCrop: false
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
    init() {
      this.$nextTick(() => {
        // WaterMark("职共名称");
        this.initSignImg()
      })
    },

    initSignImg() {
      FinanceApproval.getSignImg().then(res => {
        if (res.success) {
          this.signImg = res.result.sign
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },

    handleSignClose() {
      this.ruleSignForm.remarks = "";
      this.$emit('handleSignClose')
    },

    confirmAgree() {
      this.$refs.esign
        .generate()
        .then((res) => {
          // base64图片
          let fileImg = this.base64ImgtoFile(res)
          this.uploadImg(fileImg)
        })
        .catch((err) => {
          // 画布没有签字时会执行这里 'Not Signned'
          let data = this.signApprovalData
          data.sign = this.signImg
          data.remark = this.ruleSignForm.remarks
          this.approvalAgree(data)
        });
    },

    /* base64图片转为文件图片 */
    base64ImgtoFile(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },

    //上传图片
    uploadImg(file) {
      imgUploader
        .postImgUpload(file)
        .then(res => {
          if (res.errorCode === 0) {
            let sign = res.imgUrl
            let data = this.signApprovalData
            data.remark = this.ruleSignForm.remarks
            data.sign = sign
            this.approvalAgree(data)
          } else {
            this.$message.error("图片上传超时，请重新上传");
          }
        })
        .catch(() => {
          this.$message.error("图片上传超时，请重新上传");
        });
    },

    approvalAgree(data) {
      FinanceApproval.financeApproval(data).then(res => {
        if (res.success) {
          this.handleSignClose()
          this.$emit('signAgree')
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    },

    clearSign() {
      this.signImg = ''
      this.$refs.esign.reset();
    },
  }
}
</script>

<style lang='scss'>
.sign {
  .sign-container {
    background: #fafafa;
    margin: 0px 32px;
    position: relative;
    .clear-sign {
      position: absolute;
      right: 15px;
      bottom: 2px;
    }
    .sign-tips {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 260px;
      height: 34px;
      font-size: 36px;
      font-weight: 400;
      color: $color-Step;
      line-height: 24px;
      opacity: 0.3;
      cursor: default;
      //pointer-events: none;
    }
  }
  .tips {
    color: $color-FinancialAudit;
    font-size: $fs-small-l;
    text-align: left;
    line-height: 40px;
    padding-left: 32px;
    .tips-img {
      width: 16px;
      height: 16px;
      margin-right: 11px;
    }
    .tips-text {
      vertical-align: middle;
    }
  }
  .el-dialog .el-dialog__body .sign-ruleForm {
    padding: 20px 32px;
  }
  .el-dialog {
    .el-form-item__label {
      line-height: 24px;
    }
  }
  .sign-img {
    width: 100%;
    height: 340px;
  }
  .water-mark-wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9999;
    pointer-events: none;
    top: 0;
    left: 0;
    display: flex;
    overflow: hidden;
    flex-wrap: wrap;
  }
  .water-word {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: rgba(8, 8, 8, 0.1);
    transform: rotate(-45deg);
    user-select: none;
  }
}
</style>
